import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PopupCrossSellOfferCon from '../../../PopupCrossSellOfferCon';
import CentralLineProduct from './product';

import { MImageCarousel } from '../../../../../atoms/MImageCarousel';
import PriceDetails from '../../../../../molecules/PriceDetails';
import { MText } from '../../../../../atoms/MText';
import { MBox } from '../../../../../atoms/MBox';

import {
  StyledCentralLinePopupWidgetCon,
  StyledCentralLineProductItemCon,
} from './skins';

export default function CentralLineLayout(props) {
  const {
    isMobile,
    primary,
    products,
    selectedVariantInfo,
    popupOfferHeaderStyles,
    popupOfferBottomBarStyles,
    isShowBaseProduct,
    theme,
    onMinimizeClick,
    onCheckoutClick,
    onSkipClick,
    isBottomBarButtonActionLoading,
    offerLevelQuantityAdded,
    offerLevelDiscountQuantity,
    atcStatus,
    ...restProps
  } = props;

  return (
    <StyledCentralLinePopupWidgetCon className="mr-popup-widget mr-popup-widget--cross-sell-popup mr-popup-widget--central-line">
      <PopupCrossSellOfferCon
        isMobile={isMobile}
        onMinimizeClick={onMinimizeClick}
        onCheckoutClick={onCheckoutClick}
        onSkipClick={onSkipClick}
        popupOfferHeaderStyles={popupOfferHeaderStyles}
        popupOfferBottomBarStyles={popupOfferBottomBarStyles}
        productsContainerPadding={theme.productsContainerPadding}
        productsContainerMargin={theme.productsContainerMargin}
        isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
        offerLevelQuantityAdded={offerLevelQuantityAdded}
        offerLevelDiscountQuantity={offerLevelDiscountQuantity}
        atcStatus={atcStatus}
      >
        {isShowBaseProduct && (
          <StyledCentralLineProductItemCon
            padding={
              isMobile
                ? theme.productItemMobilePadding
                : theme.productItemPadding
            }
            margin={
              isMobile ? theme.productItemMobileMargin : theme.productItemMargin
            }
            backgroundColor={theme.baseProductBackgroundColor}
            className="mr-product-item mr-product-item--primary-product"
          >
            <MBox className="mr-product-item__body-wrapper">
              <MImageCarousel
                images={primary.images}
                imageWidth={
                  isMobile
                    ? theme.baseProductImageMobileWidth
                    : theme.baseProductImageWidth
                }
                imageHeight={
                  isMobile
                    ? theme.baseProductImageMobileHeight
                    : theme.baseProductImageHeight
                }
                imageMobileWidth={theme.baseProductImageMobileWidth}
                imageMobileHeight={theme.baseProductImageMobileHeight}
                imageIsBordered={false}
                imageBorderColor=""
                imageBorderWidth="0"
                imageBorderRadius={
                  isMobile
                    ? theme.baseProductImageMobileBorderRadius
                    : theme.baseProductImageBorderRadius
                }
                imagePadding={theme.baseProductImagePadding}
                imageMargin={theme.baseProductImageMargin}
                arrowColor={theme.productButtonColor}
                imageIndex={0}
              />
              <MBox className="mr-product-item__body">
                <MBox className="mr-product-body__details">
                  <MText
                    // isInlineText
                    color={theme.baseProductAdditionTextColor}
                    fontSize={
                      isMobile
                        ? theme.baseProductAdditionMobileFontSize
                        : theme.baseProductAdditionFontSize
                    }
                    mobileFontSize={theme.baseProductAdditionMobileFontSize}
                    textDecoration={theme.baseProductAdditionTextDecoration}
                    fontStyle={theme.baseProductAdditionFontStyle}
                    fontWeight={theme.baseProductAdditionFontWeight}
                    textAlignment={
                      isMobile
                        ? theme.productNameMobileTextAlignment
                        : theme.productNameTextAlignment
                    }
                    fontFamily={theme.baseProductAdditionFontFamily}
                    padding={
                      isMobile
                        ? theme.productNameMobilePadding
                        : theme.productNamePadding
                    }
                    margin={
                      isMobile
                        ? theme.productNameMobileMargin
                        : theme.productNameMargin
                    }
                    width="100%"
                    className="mr-product-details__product-title-con"
                  >
                    <span className="mr-product-details__added-text">
                      {theme.baseProductAdditionText}
                    </span>{' '}
                    <MText
                      isInlineText
                      color={theme.productNameTextColor}
                      fontSize={
                        isMobile
                          ? theme.baseProductAdditionMobileFontSize
                          : theme.baseProductAdditionFontSize
                      }
                      mobileFontSize={theme.baseProductAdditionMobileFontSize}
                      textDecoration={theme.productNameTextDecoration}
                      fontStyle={theme.productNameFontStyle}
                      fontWeight={theme.productNameFontWeight}
                      className="mr-product-details__product-title"
                    >
                      {primary.title}
                    </MText>
                  </MText>
                  <PriceDetails
                    offerPrice={primary.offer_price}
                    price=""
                    off=""
                    isDiscountDisabled
                    {...restProps.priceDetailStyles}
                    textAlignment={
                      isMobile
                        ? theme.productPriceMobileTextAlignment
                        : theme.productPriceTextAlignment
                    }
                    fontFamily={theme.productPriceFontFamily}
                    margin={
                      isMobile
                        ? theme.productPriceMobileMargin
                        : theme.productPriceMargin
                    }
                    padding={
                      isMobile
                        ? theme.productPriceMobilePadding
                        : theme.productPricePadding
                    }
                    className="mr-product-item__price-con"
                  />
                </MBox>
              </MBox>
            </MBox>
          </StyledCentralLineProductItemCon>
        )}
        {products.map((product, i) => (
          <Fragment key={product.id}>
            <CentralLineProduct
              isMobile={isMobile}
              product={product}
              selectedVariant={selectedVariantInfo[i]}
              theme={theme}
              {...restProps}
            />
          </Fragment>
        ))}
      </PopupCrossSellOfferCon>
    </StyledCentralLinePopupWidgetCon>
  );
}

CentralLineLayout.propTypes = {
  isAdmin: PropTypes.bool,
  isAdminMobileTab: PropTypes.bool,
  isMobile: PropTypes.bool,
  isShowBaseProduct: PropTypes.bool,
  primary: PropTypes.object,
  products: PropTypes.array,
  selectedVariantInfo: PropTypes.array,
  theme: PropTypes.object,
  popupOfferHeaderStyles: PropTypes.object,
  popupOfferBottomBarStyles: PropTypes.object,
  onMinimizeClick: PropTypes.func,
  onCheckoutClick: PropTypes.func,
  onSkipClick: PropTypes.func,
  isBottomBarButtonActionLoading: PropTypes.bool,
  offerLevelQuantityAdded: PropTypes.number,
  offerLevelDiscountQuantity: PropTypes.number,
  atcStatus: PropTypes.string,
};
